// src/components/PortalSwitcher.js
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Database, ShieldCheck, ChevronDown, ArrowRight } from 'lucide-react';

/**
 * PortalSwitcher component - Allows users to switch between user and admin portals
 */
const PortalSwitcher = ({ currentPortal = 'admin', className = '' }) => {
  const [isOpen, setIsOpen] = useState(false);
  const navigate = useNavigate();
  
  // Toggle dropdown
  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };
  
  // Handle portal switch
  const switchToPortal = (portal) => {
    if (portal === 'admin') {
      navigate('/admin/dashboard');
    } else {
      navigate('/portal');
    }
    setIsOpen(false);
  };
  
  return (
    <div className={`relative ${className}`}>
      <button
        type="button"
        className="inline-flex items-center justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-indigo-600 text-sm font-medium text-white hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
        onClick={toggleDropdown}
      >
        {currentPortal === 'admin' ? (
          <>
            <ShieldCheck className="-ml-1 mr-2 h-5 w-5" />
            Admin Portal
          </>
        ) : (
          <>
            <Database className="-ml-1 mr-2 h-5 w-5" />
            User Portal
          </>
        )}
        <ChevronDown className="ml-2 -mr-1 h-4 w-4" />
      </button>
      
      {isOpen && (
        <div className="origin-top-right absolute right-0 mt-2 w-56 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 z-20">
          <div className="py-1" role="menu" aria-orientation="vertical">
            {currentPortal !== 'admin' && (
              <button
                onClick={() => switchToPortal('admin')}
                className="w-full text-left block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                role="menuitem"
              >
                <div className="flex items-center justify-between">
                  <div className="flex items-center">
                    <ShieldCheck className="mr-3 h-5 w-5 text-indigo-500" />
                    <span>Switch to Admin Portal</span>
                  </div>
                  <ArrowRight className="h-4 w-4 text-gray-400" />
                </div>
              </button>
            )}
            {currentPortal !== 'user' && (
              <button
                onClick={() => switchToPortal('user')}
                className="w-full text-left block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                role="menuitem"
              >
                <div className="flex items-center justify-between">
                  <div className="flex items-center">
                    <Database className="mr-3 h-5 w-5 text-green-500" />
                    <span>Switch to User Portal</span>
                  </div>
                  <ArrowRight className="h-4 w-4 text-gray-400" />
                </div>
              </button>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default PortalSwitcher;